import { ReactNode } from 'react';

interface ScrollRevealSectionProps {
  children: ReactNode;
  slideProgress: number;
  framesComplete: boolean;
}

/**
 * Renders content in normal document flow on top of the fixed hero (z-20 vs z-10).
 * Native document scroll = native mobile momentum / smooth Lenis scroll.
 */
const ScrollRevealSection = ({ children }: ScrollRevealSectionProps) => {
  return (
    <div className="relative bg-background z-20">
      {children}
    </div>
  );
};

export default ScrollRevealSection;
